/* eslint-disable @typescript-eslint/naming-convention */
import { takeLatest, call, put } from 'redux-saga/effects';
import { reset, arrayRemoveAll, arrayPush, change } from 'redux-form';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import { delay } from 'redux-saga';

import * as act from '../../actions';
import * as actNotif from '../../actions/notifications';
import * as actBankAcc from '../../actions/setting/bankAccount';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';
import {
  SETTING_BANK_ACCOUNT_PAGE_REQUEST,
  SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET,
  SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_ADD_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_MODAL_ASSIGN_OUTLET,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_DELETE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_ROW_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ASSIGN_OUTLETS_MODAL,
  SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ACTIVITY_LOG_MODAL,
  SETTING_BANK_ACCOUNT_ON_CLICK_SEND_OTP,
  SETTING_BANK_ACCOUNT_ON_CHANGE_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_KEYWORD,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_BANK_ACCOUNTS,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_AVAILABLE_OUTLETS,
  SETTING_BANK_ACCOUNT_ON_LOAD_ACTIVITY_LOGS,
} from '../../actions/setting/bankAccount/constants';

import * as apiBankAcc from '../../api/bankAccounts';
import * as apiOutlet from '../../api/outlets';
import * as apiPaymentMethod from '../../api/paymentMethods';
import * as apiProfile from '../../api/profile';
import * as apiAuth from '../../api/auth';
import { useMokaOutletPropsFirst } from '../../utils/formatter';
import { assertErrorHasMessage } from '../../utils/assert';
import * as clevertapSettingsBankAccounts from '../../clevertap/settings/bankAccounts';
import {
  CLEVERTAP_BANK_ACCOUNT_OPEN_PAGE,
  CLEVERTAP_BANK_ACCOUNT_VIEW_BANK_ACCOUNT,
  CLEVERTAP_BANK_ACCOUNT_ADD_BANK_ACCOUNT,
  CLEVERTAP_BANK_ACCOUNT_EDIT_BANK_ACCOUNT,
  CLEVERTAP_BANK_ACCOUNT_SAVE_NEW_BANK_ACCOUNT,
} from '../../clevertap/constants';

function* getUserProfile() {
  try {
    return yield call(apiProfile.getProfile);
  } catch (error) {
    return null;
  }
}

function* sendClevertapTracker(actionType, bank?, outletData?) {
  try {
    // eslint-disable-next-line default-case
    switch (actionType) {
      case CLEVERTAP_BANK_ACCOUNT_OPEN_PAGE: {
        clevertapSettingsBankAccounts.accountSettingsOpenBankAccount();
        break;
      }
      case CLEVERTAP_BANK_ACCOUNT_VIEW_BANK_ACCOUNT: {
        clevertapSettingsBankAccounts.accountSettingsViewBankAccount();
        break;
      }
      case CLEVERTAP_BANK_ACCOUNT_ADD_BANK_ACCOUNT: {
        clevertapSettingsBankAccounts.accountSettingsAddBankAccount();
        break;
      }
      case CLEVERTAP_BANK_ACCOUNT_EDIT_BANK_ACCOUNT: {
        const resProfile = yield call(getUserProfile);
        if (resProfile)
          clevertapSettingsBankAccounts.accountSettingsEditSaveBankAccount(
            bank,
            outletData,
            resProfile
          );
        break;
      }
      case CLEVERTAP_BANK_ACCOUNT_SAVE_NEW_BANK_ACCOUNT: {
        const resProfile = yield call(getUserProfile);
        if (resProfile)
          clevertapSettingsBankAccounts.accountSettingsSaveNewBankAccount(
            bank,
            outletData,
            resProfile
          );
        break;
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function* resetState() {
  yield put(reset('bankAccountForm'));
  yield put(reset('assignOutletsForm'));
  yield put(actBankAcc.setBankAccountDetail(null));
  yield put(actBankAcc.hideRightColumn());
  yield put(actBankAcc.hideModalDelete());
}

function getAvailableOutletsOfBankAccount(request) {
  const { bankAccountId, outlets, bankAccounts, banks } = request.payload;
  const outletBankAccountMap = {};
  const bankMap = {};

  try {
    bankAccounts.forEach((bankAccount) => {
      bankAccount.outlets.forEach((outletId) => {
        outletBankAccountMap[outletId] = bankAccount;
      });
    });

    banks.forEach((bank) => {
      bankMap[bank.id] = bank;
    });

    return outlets
      .filter((outlet) => {
        const outletId = outlet.id;
        const outletBankAccount = outletBankAccountMap[outletId];

        return (
          outletBankAccount === undefined ||
          (outletBankAccount !== undefined &&
            outletBankAccount.business_bank_account_id !== bankAccountId)
        );
      })
      .map((outlet) => {
        const outletId = outlet.id;
        const outletBankAccount = outletBankAccountMap[outletId];
        const bank =
          outletBankAccount !== undefined
            ? bankMap[outletBankAccount.bank_id]
            : undefined;

        return {
          id: outlet.id,
          name: useMokaOutletPropsFirst(outlet, (o) => o.name),
          bankName: bank !== undefined ? bank.name : null,
          accountHolderName:
            outletBankAccount !== undefined
              ? outletBankAccount.account_holder_name
              : null,
          accountNumber:
            outletBankAccount !== undefined
              ? outletBankAccount.account_holder_number
              : null,
        };
      })
      .sort((a, b) => {
        return (
          // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
          (b.bankName === null) - (a.bankName === null) ||
          (a.name?.localeCompare(b.name) ?? 1)
        );
      });
  } catch (error) {
    return [];
  }
}

export function* emptyForm() {
  yield put(reset('bankAccount'));
}

export function* getBankList() {
  const resBankList = yield call(apiBankAcc.getAllBanks);

  const bankList = resBankList.data.map((bank) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { id, swift_code } = bank;
    const { name } = bank;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    return { id, name, swift_code };
  });
  yield put(actBankAcc.setBankList(bankList));
}

export function* getBankAccountList() {
  const resBankAccountList = yield call(apiBankAcc.getAllBackAccounts);
  yield put(actBankAcc.setBankAccountLists(resBankAccountList.data));
  yield put(actBankAcc.setSearchBankAccounts(resBankAccountList.data));

  const outletStatus: any[] = [];
  forEach(resBankAccountList.data, (bankAcc) => {
    forEach(bankAcc.outlets, (id) => {
      const outlet = {};
      (outlet as any).id = id;
      (outlet as any).bankAccId = bankAcc.business_bank_account_id;
      outletStatus.push(outlet);
    });
  });
  yield put(actBankAcc.setOutletStatus(outletStatus));
  yield put(showPageLoadingSpinner(false));
}

export function* getPaymentMethods() {
  const responsePaymentMethod = yield call(
    apiPaymentMethod.getAllPaymentMethods
  );
  const outletStatusPaymentMethod = responsePaymentMethod.data.map(
    (paymentMethod) => {
      const { code, id, outlet_statuses } = paymentMethod;
      return { code, id, outlet_statuses };
    }
  );
  yield put(actBankAcc.setPaymentMethods(outletStatusPaymentMethod));
}

export function* onClickCancelAddBank() {
  yield call(emptyForm);
  yield put(actBankAcc.setSelectedOutletsModal([]));
  yield put(actBankAcc.setBankAccountDetail(null));
  yield put(actBankAcc.hideRightColumn());
}

export function* updateStateAfterSave() {
  yield call(getBankAccountList);
  yield call(onClickCancelAddBank);

  yield put(actBankAcc.hideModalConfirmSaveAll());
  yield put(actBankAcc.hideModalConfirmChanges());
}

export function* pageRequest() {
  yield put(act.showProgressBar());
  yield put(showPageLoadingSpinner(true));
  yield call(sendClevertapTracker, CLEVERTAP_BANK_ACCOUNT_OPEN_PAGE);
  try {
    const resProfile = yield call(getUserProfile);
    yield put(actBankAcc.setProfile(resProfile.data));

    const outletsResponse = yield call(apiOutlet.outlets);
    yield put(actBankAcc.setOutlets(outletsResponse.data));

    yield call(getBankList);
    yield call(getBankAccountList);
    yield call(getPaymentMethods);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* addAssignOutlets(request) {
  const { outletList, unlinkOutlets } = request.payload;
  yield put(arrayRemoveAll('bankAccount', 'outlets'));
  yield put(arrayRemoveAll('bankAccount', 'unlinkOutlets'));

  for (let i = 0; i < outletList.length; i++) {
    yield put(arrayPush('bankAccount', 'outlets', outletList[i]));
  }
  for (let i = 0; i < unlinkOutlets.length; i++) {
    yield put(arrayPush('bankAccount', 'unlinkOutlets', unlinkOutlets[i]));
  }
  yield put(actBankAcc.hideModalAssignOutlets());
}

export function* onClickAddBank() {
  yield put(act.showProgressBar());
  yield call(sendClevertapTracker, CLEVERTAP_BANK_ACCOUNT_ADD_BANK_ACCOUNT);
  try {
    yield put(actBankAcc.setBankAccountDetail(null));
    yield put(actBankAcc.setSelectedOutletsModal([]));
    yield put(actBankAcc.showRightColumnAsForm());
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickCancelModalAssignOutlet() {
  yield put(actBankAcc.hideModalAssignOutlets());
  yield put(actBankAcc.setUnlinkOutlets([]));
}

export function* onClickSaveBank(request) {
  yield put(act.showProgressBar());
  const { bank } = request.payload;
  try {
    const bankAccReq = {
      account_holder_name: bank.accountHolderName,
      account_holder_number: bank.accountNumber,
      bank_id: bank.bankId,
    };

    const resBankAcc = yield call(apiBankAcc.postNewBankAccount, bankAccReq);
    const bankAccId = resBankAcc.data.business_bank_account_id;

    const outletData = bank.outlets.map((outlet) => {
      const { id } = outlet;
      return id;
    });

    const linkOutletReq = {
      business_bank_account_id: bankAccId,
      outlet_ids: outletData,
    };
    yield call(apiBankAcc.linkBankAccountToOutlets, linkOutletReq);

    yield put(
      actNotif.success(
        'You have successfully save bank account and its outlets'
      )
    );
    yield call(
      sendClevertapTracker,
      CLEVERTAP_BANK_ACCOUNT_SAVE_NEW_BANK_ACCOUNT,
      bank,
      outletData
    );
  } catch (error) {
    yield put(
      actNotif.error(
        'There is an error, cannot save bank or assign outlets to bank. Please try again'
      )
    );
  } finally {
    yield call(updateStateAfterSave);
    yield put(act.hideProgressBar());
  }
}

export function* onClickSaveUpdateBank(request) {
  yield put(act.showProgressBar());
  const { bank } = request.payload;
  try {
    const bankAccReq = {
      account_holder_name: bank.accountHolderName,
      account_holder_number: bank.accountNumber,
      bank_id: bank.bankId,
    };

    const resBankAcc = yield call(
      apiBankAcc.updateBankAccount,
      bankAccReq,
      bank.bankAccId
    );
    const bankAccId = resBankAcc.data.business_bank_account_id;

    const outletData = bank.outlets.map((outlet) => {
      const { id } = outlet;
      return id;
    });

    const linkOutletReq = {
      business_bank_account_id: bankAccId,
      outlet_ids: outletData,
    };
    yield call(apiBankAcc.linkBankAccountToOutlets, linkOutletReq);

    if (bank.unlinkOutlets !== undefined && bank.unlinkOutlets.length > 0) {
      const unlinkOutletReq = {
        business_bank_account_id: bankAccId,
        outlet_ids: bank.unlinkOutlets,
      };
      yield call(apiBankAcc.unlinkBankAccountFromOutlets, unlinkOutletReq);
      yield put(actBankAcc.setUnlinkOutlets([]));
    }
    yield put(
      actNotif.success(
        'You have successfully update bank account and its outlets'
      )
    );
    yield call(
      sendClevertapTracker,
      CLEVERTAP_BANK_ACCOUNT_EDIT_BANK_ACCOUNT,
      bank,
      outletData
    );
  } catch (error) {
    yield put(
      actNotif.error(
        'There is an error, cannot update bank or outlets. Please try again'
      )
    );
  } finally {
    yield call(updateStateAfterSave);
    yield put(act.hideProgressBar());
  }
}

export function* onClickRowBank(request) {
  yield put(act.showProgressBar());
  const {
    payload: { bank },
  } = request;

  const bankAccount = {
    bankName: bank.bank_name,
    bankId: bank.bank_id,
    bankAccId: bank.business_bank_account_id,
    accountNumber: bank.account_holder_number,
    accountHolderName: bank.account_holder_name,
    outlets: bank.outlets,
    newOutlets: [],
  };
  yield call(sendClevertapTracker, CLEVERTAP_BANK_ACCOUNT_VIEW_BANK_ACCOUNT);
  try {
    yield put(actBankAcc.showRightColumnAsEdit());
    yield put(actBankAcc.setBankAccountDetail(bankAccount));
    yield put(actBankAcc.setSelectedOutletsModal(bank.outlets));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onChangeKeyword(request) {
  const {
    payload: { keyword },
  } = request;

  yield put(showPageLoadingSpinner(true));
  yield put(actBankAcc.setBankAccountLists([]));
  yield put(actBankAcc.setBankAccountDetail(null));
  yield put(actBankAcc.hideRightColumn());
  yield call(delay, 300);
  try {
    const resBankAccountList = yield call(
      apiBankAcc.getAllBankAccountsByKeyword,
      keyword
    );
    yield put(actBankAcc.setBankAccountLists(resBankAccountList.data));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onClickAddBankV2() {
  yield put(reset('bankAccountForm'));
  yield put(actBankAcc.setBankAccountDetail(null));
  yield put(actBankAcc.showRightColumnAsForm());
}

export function* onClickSaveBankV2(request) {
  const { bankAccount, profile, otp_verification } = request.payload;

  const newOutletIds = bankAccount.newOutlets.map((newOutlet) => newOutlet.id);

  try {
    const bankAccReq = {
      account_holder_name: bankAccount.accountHolderName,
      account_holder_number: bankAccount.accountNumber,
      bank_id: bankAccount.bankId,
      new_outlet_ids: newOutletIds,
      otp_verification,
    };
    yield call(apiBankAcc.postNewBankAccountV2, bankAccReq);
    yield call(delay, 200);
    yield call(getBankAccountList);
    yield call(resetState);
    yield put(actNotif.success('Bank account successfully added'));

    clevertapSettingsBankAccounts.accountSettingsBankAccountAdd(
      bankAccount,
      newOutletIds,
      { data: profile }
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* onClickSaveUpdateBankV2(request) {
  const { bankAccount, profile, otp_verification } = request.payload;

  const newOutletIds = bankAccount.newOutlets.map((newOutlet) => newOutlet.id);

  try {
    const bankAccReq = {
      account_holder_name: bankAccount.accountHolderName,
      account_holder_number: bankAccount.accountNumber,
      bank_id: bankAccount.bankId,
      new_outlet_ids: newOutletIds,
      otp_verification,
    };
    yield call(
      apiBankAcc.updateBankAccountV2,
      bankAccReq,
      bankAccount.bankAccId
    );

    yield call(getBankAccountList);
    yield call(resetState);
    yield put(actNotif.success('Bank account successfully updated'));

    clevertapSettingsBankAccounts.accountSettingsBankAccountUpdate(
      bankAccount,
      newOutletIds,
      { data: profile }
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* onClickDeleteBank(request) {
  const { bankAccount, profile } = request.payload;

  try {
    yield call(apiBankAcc.deleteBankAccount, bankAccount.bankAccId);

    yield call(getBankAccountList);
    yield call(resetState);
    yield put(actNotif.success('Bank account successfully deleted'));

    clevertapSettingsBankAccounts.accountSettingsBankAccountDelete(
      bankAccount,
      profile
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* onClickOpenAssignOutletsModal(request) {
  const { selectedOutlets } = request.payload;

  yield put(actBankAcc.showModalAssignOutlets());
  yield put(actBankAcc.showLoadingSpinnerModal());

  const availableOutlets = yield call(
    getAvailableOutletsOfBankAccount,
    request
  );
  let selectedCount = 0;

  for (let i = 0; i < availableOutlets.length; i++) {
    const outletId = availableOutlets[i].id;
    const selected = find(selectedOutlets, ['id', outletId]) !== undefined;
    yield put(
      change('assignOutletsForm', `outlets[${outletId}].selected`, selected)
    );

    if (selected) {
      selectedCount++;
    }
  }

  const allSelected = selectedCount === availableOutlets.length;
  yield put(
    change('assignOutletsForm', `outletSelectAll.selected`, allSelected)
  );
  yield put(actBankAcc.setAvailableOutlets(availableOutlets));
  yield put(actBankAcc.hideLoadingSpinnerModal());
}

export function* onClickOpenActivityLogModal() {
  yield put(actBankAcc.showModalActivityLog());
  yield put(actBankAcc.showLoadingSpinnerModal());

  const page = 0;
  const size = 15;

  try {
    const resActivityLog = yield call(apiBankAcc.getActivityLogs, page, size);
    const activityLogs = resActivityLog.data.data.activity_logs;
    const hasMoreActivityLogs = activityLogs.length === size;
    yield put(actBankAcc.setActivityLogs(activityLogs));
    yield put(actBankAcc.setHasMoreActivityLogs(hasMoreActivityLogs));
    clevertapSettingsBankAccounts.accountSettingsBankAccountActivityLog();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    yield put(actBankAcc.hideLoadingSpinnerModal());
  }
}

export function* onLoadActivityLogs(request) {
  const { loadedActivityLogs } = request.payload;

  yield put(actBankAcc.showLoadingSpinnerModal());

  const size = 15;
  const page = Math.ceil(loadedActivityLogs.length / size);

  try {
    const resActivityLog = yield call(apiBankAcc.getActivityLogs, page, size);
    const activityLogs = resActivityLog.data.data.activity_logs;
    const hasMoreActivityLogs = activityLogs.length === size;
    const updatedActivityLogs = loadedActivityLogs.concat(activityLogs);
    yield put(actBankAcc.setActivityLogs(updatedActivityLogs));
    yield put(actBankAcc.setHasMoreActivityLogs(hasMoreActivityLogs));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    yield put(actBankAcc.hideLoadingSpinnerModal());
  }
}

export function* onClickSendOTP(request) {
  const { phoneNumber } = request.payload;
  const otp = {};

  try {
    const resOtp = yield call(apiAuth.generateOtpV2, phoneNumber);
    (otp as any).requestId = resOtp.data.request_id;
    (otp as any).errorCount = 0;
    (otp as any).sent = true;
    yield put(actBankAcc.setOtp(otp));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* onChangeVerifyOTP(request) {
  const { otp, code, rightColumnType } = request.payload;

  yield put(actBankAcc.showLoadingSpinnerModal());

  const updatedOtp = { ...otp };

  try {
    const response = yield call(apiAuth.verifyOtpV2, otp.requestId, code);
    request.payload.otp_verification = response.data.otp_verification;
  } catch (error) {
    updatedOtp.errorCount = otp.errorCount + 1;
    yield put(actBankAcc.setOtp(updatedOtp));
    yield put(actBankAcc.hideLoadingSpinnerModal());
    return;
  }

  if (rightColumnType === 'form') {
    yield call(onClickSaveBankV2, request);
  } else if (rightColumnType === 'edit') {
    yield call(onClickSaveUpdateBankV2, request);
  }

  yield put(actBankAcc.hideLoadingSpinnerModal());
  yield put(actBankAcc.hideModalVerifyOtp());

  updatedOtp.errorCount = 0;
  updatedOtp.sent = false;
  yield put(actBankAcc.setOtp(updatedOtp));
}

export function* onChangeSearchBankAccounts(request) {
  const { bankAccounts, banks, outlets } = request.payload;
  let { query } = request.payload;

  query = query.toLowerCase();

  yield put(showPageLoadingSpinner(true));
  yield call(delay, 100);

  try {
    bankAccounts.forEach((bankAccount) => {
      const bank = find(banks, ['id', bankAccount.bank_id]);
      bankAccount.bank_name = bank.name;

      const assignedOutlets: any[] = [];
      bankAccount.outlets.forEach((assignedOutletId) => {
        const assignedOutlet = find(outlets, ['id', assignedOutletId]);
        if (assignedOutlet !== undefined) {
          assignedOutlets.push(assignedOutlet);
        }
      });

      bankAccount.assigned_outlets = assignedOutlets;
    });

    const searchBankAccounts = bankAccounts.filter((bankAccount) => {
      const outletExist = find(bankAccount.assigned_outlets, (outlet) => {
        return outlet.name.toLowerCase().includes(query);
      });

      return (
        bankAccount.bank_name.toLowerCase().includes(query) ||
        bankAccount.account_holder_number.toLowerCase().includes(query) ||
        bankAccount.account_holder_name.toLowerCase().includes(query) ||
        outletExist !== undefined
      );
    });

    yield put(actBankAcc.setSearchBankAccounts(searchBankAccounts));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield call(resetState);
  }
}

export function* onChangeSearchAvailableOutlets(request) {
  let { query } = request.payload;

  query = query.toLowerCase();

  yield put(actBankAcc.showLoadingSpinnerModal());
  yield call(delay, 100);

  try {
    const availableOutlets = yield call(
      getAvailableOutletsOfBankAccount,
      request
    );

    const searchAvailableOutlets = availableOutlets.filter(
      (availableOutlet) => {
        return (
          availableOutlet.name.toLowerCase().includes(query) ||
          (availableOutlet.accountNumber !== null &&
            availableOutlet.bankName.toLowerCase().includes(query)) ||
          (availableOutlet.accountNumber !== null &&
            availableOutlet.accountNumber.toLowerCase().includes(query))
        );
      }
    );

    yield put(change('assignOutletsForm', `outletSelectAll.selected`, false));
    for (let i = 0; i < availableOutlets.length; i++) {
      yield put(
        change(
          'assignOutletsForm',
          `outlets[${availableOutlets[i].id}].selected`,
          false
        )
      );
    }

    yield put(actBankAcc.setAvailableOutlets(searchAvailableOutlets));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actBankAcc.hideLoadingSpinnerModal());
  }
}

export default function* bankAccountSaga() {
  yield takeLatest(SETTING_BANK_ACCOUNT_PAGE_REQUEST, pageRequest);
  yield takeLatest(SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET, addAssignOutlets);
  yield takeLatest(SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK, onClickAddBank);
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_ADD_BANK,
    onClickCancelAddBank
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_MODAL_ASSIGN_OUTLET,
    onClickCancelModalAssignOutlet
  );
  yield takeLatest(SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK, onClickSaveBank);
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK,
    onClickSaveUpdateBank
  );
  yield takeLatest(SETTING_BANK_ACCOUNT_ON_CLICK_ROW_BANK, onClickRowBank);
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_KEYWORD,
    onChangeKeyword
  );
  yield takeLatest(SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK_V2, onClickAddBankV2);
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK_V2,
    onClickSaveBankV2
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK_V2,
    onClickSaveUpdateBankV2
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_DELETE_BANK,
    onClickDeleteBank
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ASSIGN_OUTLETS_MODAL,
    onClickOpenAssignOutletsModal
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ACTIVITY_LOG_MODAL,
    onClickOpenActivityLogModal
  );
  yield takeLatest(SETTING_BANK_ACCOUNT_ON_CLICK_SEND_OTP, onClickSendOTP);
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CHANGE_VERIFY_OTP,
    onChangeVerifyOTP
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_BANK_ACCOUNTS,
    onChangeSearchBankAccounts
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_AVAILABLE_OUTLETS,
    onChangeSearchAvailableOutlets
  );
  yield takeLatest(
    SETTING_BANK_ACCOUNT_ON_LOAD_ACTIVITY_LOGS,
    onLoadActivityLogs
  );
}
